module.exports = __webpack_public_path__ + "img/onboarding1.73c64b0f.png";